module.exports = __webpack_public_path__ + "static/media/View-3.9b473a07.webp";